var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Tiktok") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-0.5,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.149,13.095C8.825,12.995 8.482,12.935 8.124,12.935C6.207,12.935 4.643,14.49 4.643,16.405C4.643,17.735 5.403,18.895 6.511,19.475C6.997,19.73 7.541,19.875 8.124,19.875C9.997,19.875 11.527,18.39 11.596,16.535L11.596,0L15.744,0C15.744,0 15.744,0.485 15.842,1.045C16.136,2.615 17.073,3.965 18.367,4.81C19.269,5.395 20.348,5.74 21.5,5.74L21.5,9.865C19.352,9.865 17.362,9.18 15.739,8.02L15.739,16.405C15.739,20.595 12.321,24 8.119,24C6.497,24 4.991,23.49 3.751,22.625C1.785,21.25 0.5,18.975 0.5,16.41C0.5,12.22 3.917,8.815 8.119,8.815C8.468,8.815 8.811,8.845 9.144,8.89L9.144,13.105L9.149,13.095Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/Tiktok.089ae74100a90de47540949cb8d0288d.svg";
export { ForwardRef as ReactComponent };